var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunderStorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,11a5.006,5.006,0,0,1-5,5,1,1,0,0,1,0-2,3,3,0,0,0,0-6,2.965,2.965,0,0,0-1,.188A1,1,0,0,1,15.73,7.6a3.977,3.977,0,0,0-7.46,0A1,1,0,0,1,7,8.188,2.965,2.965,0,0,0,6,8a3,3,0,0,0,0,6,1,1,0,0,1,0,2A5,5,0,0,1,6,6a4.608,4.608,0,0,1,.783.067,5.971,5.971,0,0,1,10.434,0A4.608,4.608,0,0,1,18,6,5.006,5.006,0,0,1,23,11ZM9.293,20.707a1,1,0,0,0,1.414,0l4-4A1,1,0,0,0,14,15H12.414l2.293-2.293a1,1,0,0,0-1.414-1.414l-4,4A1,1,0,0,0,10,17h1.586L9.293,19.293A1,1,0,0,0,9.293,20.707Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderStorm);
export default __webpack_public_path__ + "static/media/thunder-storm.ad3d0758980aed96b5ec4525553191a5.svg";
export { ForwardRef as ReactComponent };